import { Component, EventEmitter, Input, OnInit, Output, PLATFORM_ID,Inject, effect } from '@angular/core';
import { GameItem } from 'src/app/apollo/models/base-models';
import { BasePageComponent } from 'src/app/components/base-page/base-page.component';
import { SwiperBaseComponent } from '../../swiper-base/swiper-base.component';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { isPlatformBrowser } from '@angular/common';
import { BonusQueueService } from 'src/app/services/wallet/bonus-queue.service';
import { takeUntil } from 'rxjs';
import { FavouritesService } from 'src/app/services/profile/favourites.service';
import { TopGames } from 'src/app/services/profile/profile.models';
import { TopGamesService } from 'src/app/services/profile/top-games.service';

@Component({
  selector: 'app-swiper-game-categories-body',
  templateUrl: './swiper-game-categories-body.component.html',
  styleUrls: ['./swiper-game-categories-body.component.scss']
})
export class SwiperGameCategoriesBodyComponent extends SwiperBaseComponent implements OnInit {
  topGames: TopGames;
  // @Input() game: GameItem;
  isBonusExcludedGame: boolean = false;
  favouriteGame: boolean = false;
  isInTopGamesByMaxWin: boolean = false;
  isInTopGamesByTotalRounds: boolean = false;
  @Input()
  set data(dataInput: GameItem) {
    if (this.topGames) {
      this.checkTopGames();
    }
    this._data = dataInput;
  }

  get data(): any { return this._data; }

  constructor(    protected licenceService: LicenceService,
    private bonusQueueService: BonusQueueService,
    private favoriteService: FavouritesService,
    private topGamesService: TopGamesService,
    @Inject(PLATFORM_ID) private platformId,
    ) { 
      effect(() => {
        this.topGames = this.topGamesService.topGames();
        if (this._data) {
          this.checkTopGames();
        }
      });
      super() }

      badge() {
        if (this.isInTopGamesByMaxWin) {
          return 'big_win';
        } else if (this.isInTopGamesByTotalRounds) {
          return 'hot';
        } else if (this._data.tag.includes('drops_win')) {
          return 'drops_win';
        } else if (this._data.tag.includes('take_prize')) {
          return 'take_prize';
        } else if (this._data.tag.includes('cash_drops')) {
          return 'cash_drops';
        } else {
          return null;
        }
      }
  ngOnInit(): void {
    if (this.data && this.topGames) {
      this.checkTopGames();
    }

    this.favoriteService.getFavouriteGames().pipe(takeUntil(this.unsubscribe)).subscribe(
    resp => {
      this.favouriteGame = resp.map((item) => item.gameid)?.includes(this.data?.gameid);
    });
  }

  onGameClick() {
    this.onSlideClick.emit(this.data);
  }

  checkTopGames() {
    if (this.data?.gameid) {
      if (this.topGames.maxWin.includes(this.data.gameid)) {
        this.isInTopGamesByMaxWin = true;
      } else {
        if (this.isInTopGamesByMaxWin) {
          this.isInTopGamesByMaxWin = false;
        }
      }
      if (this.topGames.totalRounds.includes(this.data.gameid)) {
        this.isInTopGamesByTotalRounds = true;
      } else {
        if (this.isInTopGamesByTotalRounds) {
          this.isInTopGamesByTotalRounds = false;
        }
      }
    }
  }

  ngAfterViewInit(): void {

    if (isPlatformBrowser(this.platformId)) {
      this.bonusQueueService.getActiveBonus().pipe(takeUntil(this.unsubscribe)).subscribe(bonus => {
        this.isBonusExcludedGame = bonus?.excludedGames?.includes(this.data?.gameid)
      })
    }
  }
  
}
